
import { ArrowRight } from "lucide-react";
import AnimatedCard from "@/components/AnimatedCard";
import { Button } from "@/components/Button";
import CosmicBackground from "@/components/CosmicBackground";
import { Link } from "react-router-dom";

const HeroSection = () => {
  return (
    <section className="relative py-24 md:py-32 bg-background overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="/lovable-uploads/Office_team.png"
          alt="Office team"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background/70 to-background/70"></div>
      </div>
      
      <CosmicBackground />
      <div className="absolute inset-0 bg-grid-pattern opacity-[0.03] z-0"></div>
      <div className="container mx-auto px-6 relative z-10">
        <AnimatedCard animation="fade-in" className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            <span className="text-primary">Real Experts. Real Strategy.</span>{" "}
            <span>Boutique Support.</span>
          </h1>
          
          <p className="text-lg md:text-xl mb-12 max-w-3xl mx-auto">
            DocketLabs is an independent, boutique consultancy helping law firms cut through the noise 
            and adopt AI with clarity, confidence, and control. We're not influencers or AI hype 
            merchants — we're educators, strategists, and trusted advisors focused on what works in the real world.
          </p>
          
          <Link to="/services/strategy/free-discovery-session">
            <Button 
              variant="primary" 
              size="lg" 
              hasAnimation={true}
              className="text-base md:text-lg py-6 px-8"
            >
              Book Your Free Advisory Call
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
          <p className="mt-4 text-sm text-gray-400">No obligation. Just practical, expert insight.</p>
        </AnimatedCard>
      </div>
    </section>
  );
};

export default HeroSection;
